/** Seconds before "Resend" is offered again after a code is sent. */
export const RESEND_COOLDOWN_SECONDS = 60;

const KEY_PREFIX = 'CodeCooldown:';

/**
 * The resend countdown lives in sessionStorage (per step key) so it keeps running across a page refresh.
 * Storage can be unavailable (private mode, blocked site data), in which case the countdown just isn't kept.
 */
export const CodeCooldown = {
  start(key: string, seconds = RESEND_COOLDOWN_SECONDS): void {
    try {
      sessionStorage.setItem(KEY_PREFIX + key, String(Date.now() + seconds * 1000));
    } catch {
      // countdown only kept in memory
    }
  },

  /** Whole seconds left, 0 when resend is allowed. */
  remaining(key: string): number {
    try {
      const until = Number(sessionStorage.getItem(KEY_PREFIX + key) ?? 0);
      return Math.max(0, Math.ceil((until - Date.now()) / 1000));
    } catch {
      return 0;
    }
  },

  clear(key: string): void {
    try {
      sessionStorage.removeItem(KEY_PREFIX + key);
    } catch {
      // nothing stored
    }
  },
};
